import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { _AbcButtonComponent } from "@barthauer/abc/ui-components";

@Component({
  selector: "ubt-geods-rating",
  templateUrl: "./rating.component.html",
  styleUrls: ["./rating.component.scss"],
  imports: [_AbcButtonComponent],
})
export class RatingComponent implements OnInit {
  @Input("rating") public rating: number = 3;
  @Input("starCount") public starCount: number = 6;
  @Input("fillColor") public fillColor: string = "blue";
  @Input("emptyColor") private emptyColor: string = "gray";
  @Input("icon") public icon: string = "favorites";
  @Input("disabled") public disabled: boolean = false;
  @Output() private onRatingUpdated = new EventEmitter();

  public ratingArr = [];
  constructor() {}

  ngOnInit(): void {
    for (let index = 0; index < this.starCount; index++) {
      this.ratingArr.push(index);
    }
  }

  protected onClick(rating: number): boolean {
    this.rating = rating;
    this.onRatingUpdated.emit(rating);
    return false;
  }

  protected getColor(index: number): string {
    if (this.rating >= index + 1) {
      return this.fillColor;
    } else {
      return this.emptyColor;
    }
  }
}
